import { BRAND_REFERENCE, BRANDS } from '../../api/endpoints';
import { baseApi, listTags } from './baseApi';

const multipart =
  typeof FormData !== 'undefined'
    ? { headers: { 'Content-Type': 'multipart/form-data' } }
    : {};

export const brandsApi = baseApi.injectEndpoints({
  endpoints: (build) => ({
    getBrands: build.query({
      query: (params = {}) => ({ url: BRANDS.LIST, method: 'GET', params }),
      providesTags: (result) => listTags('Brand', result),
    }),
    getBrandById: build.query({
      query: (arg) => {
        const id = typeof arg === 'object' && arg != null ? arg.id : arg;
        const params =
          typeof arg === 'object' && arg != null ? arg.params : undefined;
        return { url: BRANDS.BY_ID(id), method: 'GET', params };
      },
      providesTags: (_r, _e, arg) => [
        { type: 'Brand', id: typeof arg === 'object' && arg != null ? arg.id : arg },
      ],
    }),
    createBrand: build.mutation({
      query: (payload) => {
        const isFormData =
          typeof FormData !== 'undefined' && payload instanceof FormData;
        return {
          url: BRANDS.LIST,
          method: 'POST',
          data: payload,
          ...(isFormData ? multipart : {}),
        };
      },
      invalidatesTags: [{ type: 'Brand', id: 'LIST' }],
    }),
    updateBrand: build.mutation({
      query: ({ id, data: updateData, params, ...rest }) => {
        const payload = updateData ?? rest;
        const isFormData =
          typeof FormData !== 'undefined' && payload instanceof FormData;
        return {
          url: BRANDS.BY_ID(id),
          // Form-data updates use POST + _method=PUT (Laravel spoofing)
          method: isFormData ? 'POST' : 'PUT',
          data: payload,
          params,
          ...(isFormData ? multipart : {}),
        };
      },
      invalidatesTags: (_r, _e, { id }) => [
        { type: 'Brand', id },
        { type: 'Brand', id: 'LIST' },
      ],
    }),
    deleteBrand: build.mutation({
      query: (id) => ({ url: BRANDS.BY_ID(id), method: 'DELETE' }),
      invalidatesTags: (_r, _e, id) => [
        { type: 'Brand', id },
        { type: 'Brand', id: 'LIST' },
      ],
    }),
    getBrandAccounts: build.query({
      query: (params = {}) => ({
        url: BRAND_REFERENCE.ACCOUNTS,
        method: 'GET',
        params,
      }),
      providesTags: (result) => listTags('PaymentAccount', result),
    }),
    getBrandCategories: build.query({
      query: (params = {}) => ({
        url: BRAND_REFERENCE.CATEGORIES,
        method: 'GET',
        params,
      }),
      providesTags: [{ type: 'Brand', id: 'CATEGORIES' }],
    }),
  }),
});

export const {
  useGetBrandsQuery,
  useLazyGetBrandsQuery,
  useGetBrandByIdQuery,
  useLazyGetBrandByIdQuery,
  useCreateBrandMutation,
  useUpdateBrandMutation,
  useDeleteBrandMutation,
  useGetBrandAccountsQuery,
  useLazyGetBrandAccountsQuery,
  useGetBrandCategoriesQuery,
  useLazyGetBrandCategoriesQuery,
} = brandsApi;
